import FilterSolidSVG from "@design-system/ui-icons/vanilla/FilterSolid"
import { createIcon } from "../createIcon"

export const FilterSolidIcon = createIcon(FilterSolidSVG)
